import {Subject} from "rxjs";
import {ISettings} from "@/model/settings/MapSettings";
import { warningToast } from 'water-layout/src/services/toastr-service';
import store from "@/store";

declare const ymaps: any;

let mapInit = false;
let mapInitFail = false;
let mapInitFailEvent: Event | string;
let mapCoordinates: number[] | null = null;
const onMapReady: Subject<any> = new Subject<any>();

export const triggerMapSettingsUpdate = () => {
    return store.dispatch('loadSettings');
}

const requestSettings = (): Promise<ISettings | null> => {
    return store.dispatch('loadSettings');
};

const setMapCoordinates = (settings: ISettings | null) => {
    if ( settings && 'mapCoordinates' in settings && settings.mapCoordinates && Array.isArray(settings.mapCoordinates) )
        mapCoordinates = settings.mapCoordinates;
};

const loadMapBundle = (settings: ISettings | null) => {
    const ymapsScript: HTMLScriptElement = document.createElement('script');
    const src = settings && settings.mapApiKey
        ? `https://api-maps.yandex.ru/2.1/?lang=ru_RU&apikey=${settings.mapApiKey}`
        : 'https://api-maps.yandex.ru/2.1/?lang=ru_RU';
    ymapsScript.setAttribute('src', src);
    document.head.appendChild(ymapsScript);

    ymapsScript.onload = () => {
        ymaps.ready( () => {
            const ymapsClustererScript: HTMLScriptElement = document.createElement('script');
            // ymapsClustererScript.setAttribute('src',"https://yandex.github.io/ymaps-pie-chart-clusterer/build/pie-chart-clusterer.min.js");
            ymapsClustererScript.setAttribute('src',"/pie-chart-clusterer.min.js");
            document.head.appendChild(ymapsClustererScript);

            ymapsClustererScript.onload = () => {
                onMapReady.next(ymaps);
                mapInit = true;
            };
            ymapsClustererScript.onerror = (error) => {
                onMapReady.error(error);
                mapInitFail = true;
                mapInitFailEvent = error;
            };
        } )
    };
    ymapsScript.onerror = (error) => {
        onMapReady.error(error);
        mapInitFail = true;
        mapInitFailEvent = error;
    };
};

export const initMap = (): void => {
    requestSettings()
        .then( settings => {
            setMapCoordinates(settings);
            if ( !settings || !('mapApiKey' in settings) || !settings.mapApiKey ) {
                if ( process.env.NODE_ENV === 'production' )
                    warningToast('Работа с Яндекс.Картами невозможна по причине отсутствия api-ключа');
                else
                    loadMapBundle(null);
            }
            else
                loadMapBundle(settings);
        } )
        .catch( () => {
            if ( process.env.NODE_ENV === 'production' )
                warningToast('Работа с Яндекс.Картами невозможна по причине отсутствия api-ключа');
            else
                loadMapBundle(null);
        } );
};

export const getMap = (): Promise<any> => {
    if ( mapInitFail )
        return Promise.reject(mapInitFailEvent);
    if ( mapInit )
        return Promise.resolve(ymaps);
    return new Promise( (resolve, reject) => {
        onMapReady.subscribe( (ymaps) => {
            resolve(ymaps);
        }, (error) => {
            reject(error);
        } );
    } );
};

export const getCoordinates = (): number[] => {
    if ( mapCoordinates != null )
        return mapCoordinates;

    const longitude = process.env.VUE_APP_DEFAULT_LONGITUDE;
    const latitude = process.env.VUE_APP_DEFAULT_LATITUDE;

    if ( longitude && latitude )
        return [parseFloat(latitude), parseFloat(longitude)];

    return [58.1434708, 52.5786252];
};
